import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsMemorizePoints extends ConditionRegistryCategory {
    label = 'MemorizePoints';
    constructor(parent) {
        super(parent);
        super.init();
    }
    wordtask_active = () => new ConditionRegistryItem({
        label: 'Wordtask ist aktiv',
        eval: ({ memorizePointsWordTask, app }) => {
            if (app.appInfo.isUserCurrentlyEditing)
                return false;
            return !!memorizePointsWordTask && memorizePointsWordTask.isActiveWordTask;
        },
    });
    isNthTaskActive = () => new ConditionRegistryItem({
        label: 'Nth Wordtask active',
        eval: ({ questionMemorizePoints, condition }) => questionMemorizePoints.memorizePointsEvaluator.numberOfCompletedWordTasks + 1 === condition.local.valueOf.number1To10,
        params: { core: ['number1To10'] },
    });
}
